var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    x: -2506,
    y: -638,
    width: 32949,
    height: 1495,
    fill: "#CCE9FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sign up"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    transform: "translate(-740 -326)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1618867778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1618867776"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -21.65,
    y: -25.65,
    width: 184.3,
    height: 138.3,
    rx: 5.65,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1618867777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8592"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1886",
    cx: 9,
    cy: 9,
    r: 14.5,
    stroke: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 3H15.75V4.5H6V3ZM3.375 4.875C2.75368 4.875 2.25 4.37132 2.25 3.75C2.25 3.12868 2.75368 2.625 3.375 2.625C3.99632 2.625 4.5 3.12868 4.5 3.75C4.5 4.37132 3.99632 4.875 3.375 4.875ZM3.375 10.125C2.75368 10.125 2.25 9.6213 2.25 9C2.25 8.3787 2.75368 7.875 3.375 7.875C3.99632 7.875 4.5 8.3787 4.5 9C4.5 9.6213 3.99632 10.125 3.375 10.125ZM3.375 15.3C2.75368 15.3 2.25 14.7963 2.25 14.175C2.25 13.5537 2.75368 13.05 3.375 13.05C3.99632 13.05 4.5 13.5537 4.5 14.175C4.5 14.7963 3.99632 15.3 3.375 15.3ZM6 8.25H15.75V9.75H6V8.25ZM6 13.5H15.75V15H6V13.5Z",
    fill: "#5E6164"
  }))))), /*#__PURE__*/React.createElement("rect", {
    x: -21.65,
    y: -25.65,
    width: 184.3,
    height: 138.3,
    rx: 5.65,
    stroke: "#EAEBEB",
    strokeWidth: 0.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.451f10077c81bcee2ee8966bb46e4691.svg";
export { ForwardRef as ReactComponent };